import { ROLE_VALUES } from "./roles";
import * as Yup from "yup";
// import { PhoneNumberUtil } from "google-libphonenumber";

// const phoneUtil = PhoneNumberUtil.getInstance();

// const isPhoneValid = (phone) => {
//   console.log({ isPhoneValid_val: phone });

//   try {
//     const number = phoneUtil.parseAndKeepRawInput(phone);
//     const regionCode = phoneUtil.getRegionCodeForNumber(number);
//     return phoneUtil.isValidNumberForRegion(number, regionCode);
//   } catch (error) {
//     return false;
//   }
// };

const optionalLeadText = () =>
  Yup.string()
    .transform((value) => value?.trim() || undefined)
    .notRequired();

const leadContactShape = {
  source: optionalLeadText().min(
    3,
    "Source must contain at least 3 characters",
  ),
  name: optionalLeadText().min(3, "Project must contain at least 3 characters"),
  mobile: optionalLeadText()
    .matches(/^\d+$/, "Mobile number must contain digits only")
    .min(5, "Mobile number must contain at least 5 digits"),
  code: Yup.string().when("mobile", {
    is: (mobile) => Boolean(String(mobile || "").trim()),
    then: (schema) => schema.required("Country code is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  clientName: Yup.string().trim().min(3).required("Client Name is Required"),
  clientEmail: optionalLeadText().email("Invalid email"),
  type: Yup.string().required("Type is required"),
  whatsapp: optionalLeadText()
    .matches(/^\+?\d+$/, "WhatsApp number must contain digits only")
    .min(5, "WhatsApp number must contain at least 5 digits"),
};

const requireLeadContact = (schema) =>
  schema.test(
    "lead-contact-required",
    "At least one contact is required",
    function (values) {
      if (values?.mobile || values?.clientEmail || values?.whatsapp)
        return true;
      return this.createError({
        path: "contact",
        message:
          "Enter at least one: mobile number, WhatsApp number, or email address",
      });
    },
  );

export const LeadSchemaAdmin = requireLeadContact(
  Yup.object().shape({
    ...leadContactShape,
    srManager: Yup.string().required("User is required"),
  }),
);

export const LeadSchema = requireLeadContact(
  Yup.object().shape({
    ...leadContactShape,
    srManager: Yup.string(),
  }),
);

export const MeetingSchema = Yup.object().shape({
  lead: Yup.string().required("Lead is required"),
  productPitch: Yup.string(),
  clientAddress: Yup.string(),
  clientCity: Yup.string(),
  clientCountry: Yup.string(),
  status: Yup.string().required("Status is required"),
  scheduleDate: Yup.date().required("Meeting date and time is required"),
  meetingMode: Yup.string()
    .oneOf(["physical", "virtual"])
    .required("Meeting type is required"),
  location: Yup.string().when("meetingMode", {
    is: "physical",
    then: (schema) => schema.trim().required("Location is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  virtualMeetingLink: Yup.string().when("meetingMode", {
    is: "virtual",
    then: (schema) =>
      schema.trim().required("Virtual meeting platform or link is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  remarks: Yup.string(),
  self: Yup.boolean().required(),
  members: Yup.array().of(Yup.string()),
});

export const BookingSchema = Yup.object().shape({
  developer: Yup.string(),
  relationshipManager: Yup.string(),
  meeting: Yup.string().required("Meeting is required"),
  projectName: Yup.string().required("Project Name is required"),
  unit: Yup.string().required("Unit is required"),
  areaSQFT: Yup.number()
    .min(100, "Area SQFT is required")
    .required("Area SQFT is required"),
  total: Yup.number()
    .min(1000, "Total must be greater than or equals to 1000")
    .required("Total is required"),
  propertyDetails: Yup.string().required("Booking Details is required"),
  paymentPlan: Yup.string().required("Payment Plan is required"),
  paymentMode: Yup.string().required("Payment Mode is required"),
  token: Yup.boolean().required("Token is required"),
  bookingAmount: Yup.number().required("Booking Amount is required"),
  // passback: Yup.number().required("Loyalty is required"),
  // passbackPerc: Yup.number(),
  clientLoyalty: Yup.number().required("Client Loyalty is required"),
  clientLoyaltyPerc: Yup.number().required("Client Loyalty % is required"),
  brokerReferral: Yup.number().required("Broker Referral is required"),
  brokerReferralPerc: Yup.number().required("Client Loyalty % is required"),
  commission: Yup.number().required("Commission is required"),
  commissionPerc: Yup.number(),
  date: Yup.date(),
  inputStatus: Yup.string(),
  agents: Yup.array(),
});

// export const BookingSchema = Yup.object().shape({
//   developer: Yup.string().required("Developer is required"),
//   relationshipManager: Yup.string(),
//   meeting: Yup.string().required("Meeting is required"),
//   projectName: Yup.string()
//     .matches(/^[A-Za-z\s]+$/, "Project Name can only contain letters")
//     .required("Project Name is required"),
//   unit: Yup.string().required("Unit is required"),
//   areaSQFT: Yup.number()
//     .min(100, "Area SQFT is required")
//     .required("Area SQFT is required"),
//   total: Yup.number()
//     .min(1000, "Total must be greater than or equals to 1000")
//     .required("Total is required"),
//   propertyDetails: Yup.string().required("Booking Details is required"),
//   paymentPlan: Yup.string()
//     // .matches(/^[A-Za-z\s]+$/, "Payment Plan can only contain letters")
//     .required("Payment Plan is required"),
//   paymentMode: Yup.string().required("Payment Mode is required"),
//   token: Yup.boolean().required("Token is required"),
//   bookingAmount: Yup.number()
//     .required("Booking Amount is required")
//     .test(
//       "is-less-than-total",
//       "Booking Amount must be less than Total",
//       function (value) {
//         const { total } = this.parent;
//         return value < total;
//       }
//     ),
//   clientLoyalty: Yup.number().required("Client Loyalty is required"),
//   clientLoyaltyPerc: Yup.number().required("Client Loyalty % is required"),
//   brokerReferral: Yup.number().required("Broker Referral is required"),
//   brokerReferralPerc: Yup.number().required("Client Loyalty % is required"),
//   commission: Yup.number().required("Commission is required"),
//   commissionPerc: Yup.number(),
//   date: Yup.date(),
//   inputStatus: Yup.string(),
//   agents: Yup.array(),
// });

export const UserSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid Email").required("Email is required"),
  role: Yup.string()
    .oneOf([...ROLE_VALUES], "Invalid role")
    .required("Role is required"),
});

export const TeamSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  higher: Yup.string(),
  srManagerId: Yup.string(),
  managerId: Yup.string(),
  // managerId: Yup.string().required("Manager is required"),
  teamLeadId: Yup.string(),
  agents: Yup.array(),
});

export const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().min(8).required("Old Password is required"),
  newPassword: Yup.string().min(8).required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Please confirm your password"),
});

export const ForgetChangeSchema = Yup.object().shape({
  password: Yup.string().min(8).required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Please confirm your password"),
});

export const RescheduleSchema = Yup.object().shape({
  scheduleDate: Yup.string().required("Date and Time is required"),
  location: Yup.string(),
  productPitch: Yup.string().optional(),
  remarks: Yup.string().required("Remarks is required"),
  self: Yup.boolean().required(),
  members: Yup.array().of(Yup.string()),
  meetingMode: Yup.string().oneOf(["physical", "virtual"]).required(),
  virtualMeetingLink: Yup.string().when("meetingMode", {
    is: "virtual", then: (schema) => schema.trim().required("Virtual meeting platform or link is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const HrmsAddUserSchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobile: Yup.number().min(12).required("Mobile is Required"),
  empCode: Yup.string(),
  salary: Yup.number()
    .typeError("Salary must be a number")
    .min(0, "Salary cannot be negative"),
  dateOfJoining: Yup.date().required("Date of joining is required"),
  activeStatus: Yup.string().required("Active status is required"),
  srManager: Yup.string(),
  team: Yup.string().when("createPNL", {
    is: false, // only required if createPNL is false
    then: (schema) => schema.required("Team is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // role validation with createPNL condition
  role: Yup.string()
    .oneOf([...ROLE_VALUES], "Invalid role")
    .when("createPNL", {
      is: false, // only required if createPNL is false
      then: (schema) => schema.required("Role is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  teamName: Yup.string().when("team", {
    is: "new",
    then: (schema) => schema.required("Team name is required"),
  }),
});

export const InterviewSchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  date: Yup.date()
    .required("Interview date and time is required")
    .typeError("Valid date and time required"),
  referredBy: Yup.string().required("Referred By is required"),
  qualification: Yup.string().required("Qualification is required"),
  beforeInterview: Yup.string().required("CV is required"),
  realEstateExperience: Yup.number()
    .typeError("Experience must be a number")
    .min(0, "Experience cannot be negative")
    .required("Real estate experience is required"),
  designation: Yup.string().required("Designation is required"),
});

export const PostInterviewSchema = Yup.object({
  remarks: Yup.string().required("Remarks are required"),
  reportingManager: Yup.string().required("Reporting Manager is required"),
  salaryOffered: Yup.string()
    .matches(/^\d+$/, "Salary must be a number")
    .required("Salary Offered is required"),
  joiningDate: Yup.string().required("Joining Date is required"),
  offerAccepted: Yup.string()
    .oneOf(["yes", "no"], "Select Yes or No")
    .required("Offer acceptance is required"),
  offerLetter: Yup.string().required("Offer letter file is required"),
  afterInterview: Yup.string().required("After interview file is required"),
  pnl: Yup.string().required("PNL is required"),
});

export const RescheduleInterviewSchema = Yup.object({
  remarks: Yup.string().required("Remarks are required"),
  time: Yup.date()
    .required("Date and time is required")
    .typeError("Valid date and time required"),
});

export const ReferralEditSchema = Yup.object().shape({
  clientName: Yup.string().required("Name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  passportNumber: Yup.string().required("Passport number is required"),
  eidNumber: Yup.string().required("EID number is required"),
  nationality: Yup.string().required("Nationality is required"),
  address: Yup.string().required("Address is required"),
  passportDocument: Yup.string().required("Passport upload is required"),
  visaDocument: Yup.string().required("Visa upload is required"),
  eidDocument: Yup.string().required("EID upload is required"),
});

export const InterviewStatusSchema = Yup.object({
  remarks: Yup.string().required("Remarks are required"),
  newStatus: Yup.string().required("Status is Required"),
});

export const HolidaySchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  startDate: Yup.date()
    .required("Start date is required")
    .typeError("Valid date required"),
  endDate: Yup.date()
    .required("End date is required")
    .typeError("Valid date required")
    .min(Yup.ref("startDate"), "End date must be after start date"),
});

export const HolidayAssignmentSchema = Yup.object()
  .shape({
    users: Yup.array(),
    departments: Yup.array(),

    excludedHolidays: Yup.array(),

    customHolidays: Yup.array()
      .of(
        Yup.object().shape({
          holiday: Yup.string().required("Holiday ID missing"),
          startDate: Yup.string().nullable(),
          endDate: Yup.string().nullable(),
        }),
      )
      .test(
        "customHolidays-valid-dates",
        "Start and End date are required for all custom holidays",
        (value) => {
          if (!value || value.length === 0) return true;
          return value.every((item) => !!item.startDate && !!item.endDate);
        },
      ),
  })
  .test(
    "users-or-departments-required",
    "Select at least one user or department",
    function (value) {
      const users = value.users || [];
      const departments = value.departments || [];
      return users.length > 0 || departments.length > 0;
    },
  );

export const ShiftSchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  startTime: Yup.string().required("Start time is required"),
  endTime: Yup.string().required("End time is required"),
});

// export const offDaysSchema = Yup.object()
//   .shape({
//     users: Yup.array(),
//     departments: Yup.array(),
//     offDayType: Yup.string().oneOf(
//       ["every", "custom", ""],
//       "Invalid off day type"
//     ),

//     everyDays: Yup.array().when("offDayType", {
//       is: "every",
//       then: Yup.array().min(1, "Please select at least one day"),
//       otherwise: Yup.array(),
//     }),

//     customDays: Yup.array().when("offDayType", {
//       is: "custom",
//       then: Yup.array()
//         .min(1, "Please add at least one custom day")
//         .of(
//           Yup.object().shape({
//             week: Yup.string().required("Week is required"),
//             day: Yup.string().required("Day is required"),
//           })
//         ),
//       otherwise: Yup.array(),
//     }),
//   })
//   // ✅ Custom test to ensure one of users or departments is selected (not both or none)
//   .test(
//     "either-users-or-departments",
//     "Please select either users or departments (not both)",
//     function (values) {
//       const hasUsers = values.users && values.users.length > 0;
//       const hasDepartments =
//         values.departments && values.departments.length > 0;
//       return (hasUsers || hasDepartments) && !(hasUsers && hasDepartments);
//     }
//   );

export const AllowanceSchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  description: Yup.string().required("Description is required"),
});

export const updateSalaryStatusSchema = Yup.object().shape({
  status: Yup.string().required("Status is required"),
  paymentMethod: Yup.string().when("status", {
    is: (val) => val?.toLowerCase() === "paid",
    then: (schema) => schema.required("Payment method is required"),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
});

export const EventSchema = Yup.object().shape({
  title: Yup.string()
    .min(3, "Name must be at least 3 characters")
    .required("Name is required"),
  eventType: Yup.string().required("Event type is required"),
  projectIds: Yup.array().of(Yup.string().required()).default([]),
  description: Yup.string().nullable(),

  startDateTime: Yup.date().required("Start Date & Time is required"),
  endDateTime: Yup.date()
    .test(
      "after-start-date-time",
      "End Date & Time must be after Start Date & Time",
      function (endDateTime) {
        const { startDateTime } = this.parent;
        return (
          !startDateTime ||
          !endDateTime ||
          new Date(endDateTime) > new Date(startDateTime)
        );
      },
    )
    .required("End Date & Time is required"),

  location: Yup.string().nullable(),
  formDefinition: Yup.object({
    enabled: Yup.boolean().default(false),
    defaultProjectId: Yup.string().nullable(),
    timeZone: Yup.string().when("enabled", {
      is: true,
      then: (schema) => schema.required("Registration timezone is required"),
    }),
    title: Yup.string().nullable(),
    description: Yup.string().nullable(),
    successMessage: Yup.string().nullable(),
    fields: Yup.array()
      .of(
        Yup.object({
          id: Yup.string().required(),
          label: Yup.string().required("Every form field needs a label"),
          type: Yup.string()
            .oneOf([
              "text",
              "email",
              "phone",
              "number",
              "textarea",
              "select",
              "multi-select",
              "radio",
              "checkbox",
              "date",
              "date-time",
              "attendance-date",
              "time-slot",
            ])
            .required(),
          required: Yup.boolean(),
          placeholder: Yup.string().nullable(),
          helpText: Yup.string().nullable(),
          options: Yup.array(),
        }),
      )
      .test(
        "one-special-field",
        "Only one attendance date and one time slot field are allowed",
        (fields = []) =>
          ["attendance-date", "time-slot"].every(
            (type) => fields.filter((field) => field.type === type).length <= 1,
          ),
      ),
  }),

  // registrationDeadline: Yup.date()
  //   .nullable()
  //   .max(
  //     Yup.ref("startDateTime"),
  //     "Registration deadline must be before the event start time"
  //   ),
});

export const InvitationSchema = Yup.object().shape({
  eventId: Yup.string().required("Event is required"),
  clientName: Yup.string().required("Client Name is required"),
  clientEmail: Yup.string().email().required("Client Email is required"),
  whatsappNum: Yup.string().required("Whatsapp Number is required"),
  leadId: Yup.string().nullable(),
  company: Yup.string(),
  source: Yup.string(),
  comment: Yup.string(),
});
